var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContact = function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.711
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.947 16.933h1.474c1.425 0 2.579-.758 2.579-2.133v-2.133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.737 16.933c0 .59.495 1.067 1.105 1.067s1.105-.478 1.105-1.067-.494-1.066-1.105-1.066c-.61 0-1.105.477-1.105 1.066zm-4.79-2.844H4.474C3.66 14.089 3 13.452 3 12.667v-2.134c0-.785.66-1.422 1.474-1.422h1.473v4.978zm8.106 0h1.473c.814 0 1.474-.637 1.474-1.422v-2.134c0-.785-.66-1.422-1.474-1.422h-1.473v4.978z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10.533V8.756C3 5.025 6.134 2 10 2s7 3.025 7 6.756v1.777"
  }))));
};
export default SvgContact;